import { ErrorState, IconTitle, Loading, StatsCard } from '@dec/shared';
import { FileBarGraph, Person } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { useTaxpayerRecent } from '../hooks/useTaxpayerRecent';
import { type TaxpayerSummary } from '../models/Taxpayer';

export const TaxpayerRecentCard = () => {
  const { t } = useTranslation();
  const { data: stats, isLoading, error, refetch } = useTaxpayerRecent();

  return (
    <div>
      <div className="card">
        <div className="card-header bg-soft">
          <IconTitle
            title={t('dashboard.taxpayers')}
            icon={FileBarGraph}
            subtitle={t('dashboard.taxpayersRecent')}
          />
        </div>
        <div className="card-body">
          {isLoading && <Loading />}

          {error && <ErrorState onRetry={() => void refetch()} />}

          {!isLoading && !error && (
            <div className="row">
              {(stats ?? []).map((item: TaxpayerSummary) => (
                <div className="col-12 col-md-12 col-xxl-6 mb-2" key={item.id}>
                  <StatsCard
                    title={item.name}
                    type="text"
                    value={item.tin}
                    valueDate={item.registrationDate}
                    icon={Person}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
